/*
 * STORMWARD · Stufen im Kaufblock
 * ---------------------------------------------------------------------------
 * Drei Aufgaben, mehr nicht:
 *   1. Die gewaehlte Stufe schreibt ihre Gesamtmenge in das versteckte
 *      quantity-Feld, das per form= an Dawns Kaufformular haengt.
 *   2. Der Kaufknopf nennt den Preis der Stufe (CSS-Variable, Markup bleibt Dawn).
 *   3. ?qty=5 in der Adresse waehlt die Stufe mit dieser Gesamtmenge vor
 *      (Links aus Szenario-Kacheln und Anzeigen).
 *
 * Was hier NICHT passiert: kein fetch, keine Cart-Route, kein Nachbau des
 * Formulars. Dawns <product-form>, product-form.js und name="id" bleiben.
 * Die Zugabe wird an der Kasse durch die automatischen Rabattregeln des
 * Shops kostenlos (Buy X get Y), nicht durch einen Preis im Theme.
 *
 * Fallback ohne JavaScript: das quantity-Feld traegt die Menge der
 * vorausgewaehlten Stufe aus Liquid. Es landet nie ein leerer Korb.
 *
 * Vereinfachung gegenueber Bachgolds mt-stufen.js (items[]-Tausch): Stormward
 * hat EIN Produkt, die Zugabe ist dasselbe Produkt, also reicht eine Zeile
 * mit der Gesamtmenge.
 *
 * Seit 08.10.2026 (Muster Men Go To Mars) zusaetzlich:
 *   4. Deal-Zeile unter den Stufen: Preis gross, Wert gestrichen, rechts
 *      "% off" und "No code required".
 *   5. Ereignis "sw:tier" auf document, damit Sticky-Leiste und andere
 *      Bausteine die gewaehlte Stufe kennen (sw-sales.js).
 *   6. Upgrade-Fenster beim Kaufklick: Wer nicht die oberste Stufe nimmt,
 *      sieht einmal pro Seitenaufruf die naechstgroessere Stufe im Vergleich
 *      (Muster: "Upgrade to the full 90-day commitment"). Abfangen in der
 *      Capture-Phase auf document, BEVOR Dawns product-form den Submit
 *      bekommt. Nach der Wahl wird das Formular normal abgeschickt, Dawns
 *      Kaufweg bleibt unberuehrt.
 */
// In einem Block, damit doppeltes Laden (zwei Stufen-Bloecke, Theme-Editor) keinen
// "already declared"-Fehler wirft.
(() => {
if (customElements.get('sw-tiers')) return;
class SWTiers extends HTMLElement {
  connectedCallback() {
    this.inputs = [...this.querySelectorAll('.sw-tiers__input')];
    this.qty = this.querySelector('[data-sw-quantity]');
    if (!this.inputs.length || !this.qty) return;

    try {
      const wanted = new URLSearchParams(location.search).get('qty');
      if (wanted) {
        const hit = this.inputs.find((i) => i.dataset.total === wanted && !i.disabled);
        if (hit) hit.checked = true;
      }
    } catch (e) {}

    this.inputs.forEach((i) => i.addEventListener('change', () => this.apply()));

    this.deal = this.querySelector('[data-sw-deal]');
    this.money = this.makeMoney(this.dataset.currency);
    this.upgradeOffered = false;
    this.onSubmitCapture = this.onSubmitCapture.bind(this);
    document.addEventListener('submit', this.onSubmitCapture, true);
    this.placeMediaBadge();

    // Variantenwechsel: Dawn holt die Sektion neu und tauscht Preis, Bestand
    // und id-Feld. Die Karten tragen dann noch die Preise der alten Variante,
    // deshalb werden sie aus genau diesem HTML uebernommen.
    const info = this.closest('product-info');
    if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
      this.unsubscribe = subscribe(PUB_SUB_EVENTS.variantChange, (msg) => {
        const data = msg && msg.data;
        if (!data || !data.html) return;
        if (info && data.sectionId !== info.sectionId) return;
        this.adopt(data.html);
      });
    }

    this.apply();
  }

  disconnectedCallback() {
    if (this.unsubscribe) this.unsubscribe();
    document.removeEventListener('submit', this.onSubmitCapture, true);
  }

  makeMoney(currency) {
    try {
      const fmt = new Intl.NumberFormat('en-US', { style: 'currency', currency: currency || 'USD' });
      return (cents) => fmt.format(Number(cents) / 100);
    } catch (e) {
      return (cents) => (Number(cents) / 100).toFixed(2);
    }
  }

  tier(input) {
    const d = input.dataset;
    const cents = Number(d.cents);
    const total = Number(d.total);
    return {
      input,
      name: d.name,
      total,
      free: Number(d.free || 0),
      cents,
      valueCents: Number(d.valueCents),
      per: Math.round(cents / Math.max(total, 1)),
    };
  }

  selected() {
    return this.inputs.find((i) => i.checked && !i.disabled);
  }

  // Liste ist von oben teuer nach unten guenstig sortiert. Die naechstgroessere
  // Stufe ist also die verfuegbare Karte direkt DARUEBER.
  biggerThan(input) {
    const idx = this.inputs.indexOf(input);
    for (let k = idx - 1; k >= 0; k--) {
      if (!this.inputs[k].disabled) return this.inputs[k];
    }
    return null;
  }

  renderDeal(t) {
    if (!this.deal) return;
    const off = t.valueCents > t.cents ? Math.floor(((t.valueCents - t.cents) * 100) / t.valueCents) : 0;
    this.deal.querySelector('[data-sw-deal-now]').textContent = this.money(t.cents);
    const was = this.deal.querySelector('[data-sw-deal-was]');
    was.textContent = off > 0 ? this.money(t.valueCents) : '';
    this.deal.querySelector('[data-sw-deal-pct]').textContent = off;
    this.deal.classList.toggle('sw-deal--nooff', off <= 0);
    this.deal.hidden = false;
  }

  placeMediaBadge() {
    const text = this.dataset.mediaBadge;
    const info = this.closest('.product') || document;
    const first = info.querySelector('.product__media-list .product__media-item, .product__media-wrapper .product__media-item');
    if (!text || !first || first.querySelector('.sw-media-badge')) return;
    // In den Bild-Container (position: relative bei Dawn), nicht ins li:
    // Dawns Slider-Regeln setzen die li-Kinder sonst in den Fluss.
    const host = first.querySelector('.product-media-container') || first;
    const badge = document.createElement('span');
    badge.className = 'sw-media-badge';
    badge.textContent = text;
    host.appendChild(badge);
  }

  onSubmitCapture(evt) {
    const form = evt.target;
    if (!form || form.id !== this.dataset.form) return;
    if (this.passThrough) return;
    const sel = this.selected();
    const up = !this.upgradeOffered && sel && this.biggerThan(sel);
    if (up) {
      evt.preventDefault();
      evt.stopImmediatePropagation();
      this.upgradeOffered = true;
      this.openUpgrade(this.tier(sel), this.tier(up), form);
      return;
    }
    if (this.addonChecked()) {
      evt.preventDefault();
      evt.stopImmediatePropagation();
      this.proceed(form);
    }
  }

  addonChecked() {
    const box = this.querySelector('[data-sw-pdp-addon]');
    return !!(box && box.checked);
  }

  // Upsell zuerst in den Warenkorb (falls noch nicht drin), dann Dawns Kaufweg.
  // Scheitert der Zusatz, wird trotzdem gekauft: der Filter geht vor.
  async proceed(form) {
    const box = this.querySelector('[data-sw-pdp-addon]');
    const btn = form.querySelector('[type="submit"]');
    if (box && box.checked) {
      if (btn) btn.setAttribute('aria-busy', 'true');
      try {
        const r = window.routes || {};
        const cart = await fetch(`${r.cart_url || '/cart'}.js`, { headers: { Accept: 'application/json' } }).then((x) => x.json());
        const id = String(box.dataset.swPdpAddon);
        const has = (cart.items || []).some((i) => String(i.variant_id) === id);
        if (!has) {
          await fetch(`${r.cart_add_url || '/cart/add'}.js`, {
            method: 'POST',
            headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
            body: JSON.stringify({ items: [{ id: Number(id), quantity: 1 }] }),
          });
        }
      } catch (e) {}
      if (btn) btn.removeAttribute('aria-busy');
    }
    this.passThrough = true;
    try {
      if (typeof form.requestSubmit === 'function') form.requestSubmit();
      else form.querySelector('[type="submit"]')?.click();
    } finally {
      this.passThrough = false;
    }
  }

  fill(str, map) {
    return String(str || '').replace(/\{(\w+)\}/g, (m, k) => (k in map ? map[k] : m));
  }

  openUpgrade(cur, up, form) {
    const d = this.dataset;
    const diff = this.money(up.cents - cur.cents);
    const more = up.total - cur.total;

    const dlg = document.createElement('dialog');
    dlg.className = 'sw-upgrade color-scheme-2';
    dlg.setAttribute('aria-labelledby', 'sw-upgrade-title');
    dlg.innerHTML = `
      <button type="button" class="sw-upgrade__close" data-act="close" aria-label="Close">×</button>
      <p class="sw-upgrade__title" id="sw-upgrade-title"></p>
      <p class="sw-upgrade__more"></p>
      <div class="sw-upgrade__compare">
        <div class="sw-upgrade__opt" data-opt="cur"><p class="sw-upgrade__name"></p><p class="sw-upgrade__count"></p><p class="sw-upgrade__per"></p><p class="sw-upgrade__price"></p></div>
        <div class="sw-upgrade__opt sw-upgrade__opt--best" data-opt="up"><span class="sw-upgrade__badge"></span><p class="sw-upgrade__name"></p><p class="sw-upgrade__count"></p><p class="sw-upgrade__per"></p><p class="sw-upgrade__price"></p></div>
      </div>
      <button type="button" class="button sw-upgrade__yes" data-act="yes"></button>
      <button type="button" class="sw-upgrade__no" data-act="no"></button>`;

    const set = (sel, text) => { const el = dlg.querySelector(sel); if (el) el.textContent = text; };
    set('.sw-upgrade__title', d.upTitle);
    set('.sw-upgrade__more', this.fill(d.upMore, { diff, more }));
    [['cur', cur], ['up', up]].forEach(([key, t]) => {
      const box = dlg.querySelector(`[data-opt="${key}"]`);
      box.querySelector('.sw-upgrade__name').textContent = t.name;
      const unit = t.total === 1 ? (d.upFilter || d.upFilters) : d.upFilters;
      box.querySelector('.sw-upgrade__count').textContent = `${t.total} ${unit}${t.free ? ` (${t.free} free)` : ''}`;
      box.querySelector('.sw-upgrade__per').textContent = `${this.money(t.per)} ${d.upPer}`;
      box.querySelector('.sw-upgrade__price').textContent = this.money(t.cents);
    });
    set('.sw-upgrade__badge', d.upBadge);
    set('.sw-upgrade__yes', this.fill(d.upYes, { name: up.name }));
    set('.sw-upgrade__no', this.fill(d.upNo, { name: cur.name }));

    const submit = () => this.proceed(form);
    const finish = (act) => {
      dlg.close();
      dlg.remove();
      if (act === 'yes') {
        up.input.checked = true;
        this.apply();
        submit();
      } else if (act === 'no') {
        submit();
      }
    };
    dlg.addEventListener('click', (e) => {
      const act = e.target.closest('[data-act]')?.dataset.act;
      if (act) finish(act);
      else if (e.target === dlg) finish('close');
    });
    dlg.addEventListener('cancel', (e) => { e.preventDefault(); finish('close'); });
    document.body.appendChild(dlg);
    dlg.showModal();
    dlg.querySelector('.sw-upgrade__yes').focus();
  }

  adopt(html) {
    const fresh = html.querySelector('sw-tiers');
    if (!fresh) return;
    this.inputs.forEach((input) => {
      const twin = fresh.querySelector(`.sw-tiers__input[value="${input.value}"]`);
      if (!twin) return;
      input.disabled = twin.disabled;
      input.dataset.price = twin.dataset.price;
      const card = input.nextElementSibling;
      const twinCard = twin.nextElementSibling;
      if (card && twinCard && card.matches('.sw-tier') && twinCard.matches('.sw-tier')) {
        card.innerHTML = twinCard.innerHTML;
      }
    });
    const chosen = this.inputs.find((i) => i.checked);
    if (chosen && chosen.disabled) {
      const other = this.inputs.find((i) => !i.disabled);
      if (other) other.checked = true;
    }
    this.apply();
  }

  apply() {
    const sel = this.selected();
    if (!sel) return;
    this.qty.value = sel.dataset.total;
    const t = this.tier(sel);
    this.renderDeal(t);
    document.dispatchEvent(new CustomEvent('sw:tier', { detail: { name: t.name, total: t.total, free: t.free, price: this.money(t.cents), value: this.money(t.valueCents), form: this.dataset.form } }));

    const container = this.closest('.product__info-container') || this.closest('.shopify-section');
    if (container) {
      container.classList.add('sw-has-tiers');
      container.style.setProperty('--sw-cta-price', `' · ${sel.dataset.price}'`);
    }
  }
}

customElements.define('sw-tiers', SWTiers);
})();
